import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TerminalWindow from '../components/TerminalWindow';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center py-8 px-2 bg-[#181a1b]" dir="ltr">
      <TerminalWindow prompt="abdelhadi@blog:~$" className="w-full max-w-2xl">
        <div className="flex flex-col gap-6 font-mono animate-fadein text-left">
          <div className="text-[#ff5555] text-lg font-bold mb-2">command not found: <span className="text-[#e5e5e5]">/404</span></div>
          <div className="text-[#e5e5e5] mb-4">Oops! The page you&#39;re looking for does not exist or has wandered off into the digital wilderness.</div>
          <div className="flex flex-wrap gap-4 mt-2">
            <Link to="/" className="px-4 py-2 bg-[#23272e] text-[#00ff66] rounded-lg border border-[#39c5bb] hover:bg-[#181a1b] hover:border-[#00ff66] transition-all duration-200 font-mono">Back to Home</Link>
            <Link to="/about" className="px-4 py-2 bg-[#23272e] text-[#39c5bb] rounded-lg border border-[#00ff66] hover:bg-[#181a1b] hover:border-[#39c5bb] transition-all duration-200 font-mono">About Me</Link>
          </div>
        </div>
      </TerminalWindow>
      <div className="pointer-events-none fixed inset-0 z-0 opacity-10" style={{background: 'radial-gradient(circle at 60% 40%, #00ff66 0%, transparent 60%)'}} />
    </div>
  );
};

export default NotFound; 